import { createAction, props } from '@ngrx/store';

export const togglShowSideFilter = createAction(
  '[UI] mostrar / esconder menu lateral de filtros'
)
